module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma/5-d591425dd472f99b29e0569623b6f2a8.png";